import React from 'react'

interface Props {
  className?: string
  fill?: string
}
export const Cross = ({ className, fill = '#fff' }: Props) => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.517 10.04L.079 18.431l1.39 1.383 8.438-8.393L18.53 20l1.39-1.383-8.624-8.578L20 1.382 18.61 0 9.907 8.657 1.39.185 0 1.567l8.517 8.472z"
      fill={fill}
    />
  </svg>
)
